<template>
  <div class="presentation-owner">
    <aha-avatar
      :name="ownerName"
      :image="ownerAvatar"
      :id="ownerId"
      class="mr-1 flex-shrink-0"
    />
    <div class="presentation-owner__name">
      {{ ownerName }}
    </div>
  </div>
</template>

<script>
import EmailUtils from '@/utils/email'

export default {
  props: {
    presentation: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ownerAvatar() {
      return this.presentation.User && this.presentation.User.avatar
    },
    ownerId() {
      return this.presentation.User.id
    },
    ownerName() {
      if (this.presentation.User) {
        if (this.presentation.User.firstName) {
          return `${this.presentation.User.firstName} ${this.presentation.User.lastName}`
        }
        if (this.presentation.User.email) {
          return EmailUtils.getEmailName(this.presentation.User.email)
        }
      }
      return null
    },
  },

  methods: {

  },
}
</script>

<style lang="scss" scoped>
.presentation-owner {
  @apply flex flex-row items-center;
}
.presentation-owner__avatar {
  @apply rounded-full flex items-center justify-center mr-1;
  @apply text-base-0 uppercase;
  .__image {
    @apply rounded-full border border-primary-80;
  }
  width: 28px;
  height: 28px;
}
.presentation-owner__name {
  @apply capitalize truncate max-w-24 xl:max-w-40 text-xs;
}
</style>>
